import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  InputLabel,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../../../apis/admin-apis/AuthApis";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);
      setErrorMessage("");

      const response = await loginAdmin({
        email,
        password,
      });

      if (!response?.success || !response?.token) {
        throw new Error("Login failed. Please try again.");
      }

      localStorage.setItem("adminToken", response.token);
      localStorage.setItem("userDetails", JSON.stringify(response.user || {}));

      navigate("/admin/dashboard");
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to login. Please check your credentials.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      className="admin-login-page"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0F1E3D", // Dark navy background
        fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
      }}
    >
      <Card
        className="login-card"
        sx={{
          width: "100%",
          maxWidth: 400,
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          margin: "25px",
        }}
      >
        {/* Header Section */}
        <Box
          className="login-header"
          sx={{ textAlign: "left", marginBottom: "24px" }}
        >
          <Typography
            variant="h5"
            className="login-title"
            sx={{
              fontWeight: 700,
              color: "#0F1E3D",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            🔐 Admin Login
          </Typography>
          <Typography
            variant="body2"
            className="login-subtitle"
            sx={{ color: "#666", marginTop: "4px" }}
          >
            Taylor Campaign Dashboard
          </Typography>
        </Box>

        {/* Form Section */}
        <form onSubmit={handleLogin}>
          {errorMessage ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          ) : null}

          <Box className="form-group" sx={{ marginBottom: "20px" }}>
            <InputLabel
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#333",
                marginBottom: "8px",
              }}
            >
              Email
            </InputLabel>
            <TextField
              className="login-input-email"
              fullWidth
              variant="outlined"
              value={email}
              placeholder="example@gmail.com"
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#E8F0FE", // Light blue tint
                  "& fieldset": { border: "none" },
                  borderRadius: "6px",
                },
              }}
            />
          </Box>

          <Box className="form-group" sx={{ marginBottom: "24px" }}>
            <InputLabel
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#333",
                marginBottom: "8px",
              }}
            >
              Password
            </InputLabel>
            <TextField
              className="login-input-password"
              fullWidth
              type="password"
              variant="outlined"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#E8F0FE",
                  "& fieldset": { border: "none" },
                  borderRadius: "6px",
                },
              }}
            />
          </Box>

          <Button
            className="login-submit-button"
            fullWidth
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            sx={{
              backgroundColor: "#C4912E", // Gold color from image
              textTransform: "none",
              fontWeight: 600,
              padding: "10px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "#A67A26",
              },
            }}
          >
            {isSubmitting ? "Logging in..." : "Login"}
          </Button>
        </form>
      </Card>
    </Box>
  );
};

export default Auth;
